export default __webpack_public_path__ + "static/media/d10a976acec785778835e918e6eb4cb8.svg";